<ng-container>
  <div
    class="modal micromodal-slide"
    [id]="modalId"
    aria-hidden="true"
    tabindex="-1"
    [attr.aria-labelledby]="'multi-vin-modal-title'">

    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
      <div
        class="modal__container modal--multi-vin"
        role="dialog"
        aria-modal="true"
        [attr.aria-labelledby]="'multi-vin-modal-title'"
        [attr.data-track-region]="dialogHeadline">

        <!-- Modal Header -->
        <header class="modal__header">
          <h1
            id="multi-vin-modal-title"
            class="modal__title fw-normal"
            tabindex="-1">
            {{ dialogHeadline }}
          </h1>
        </header>

        <!-- Modal Content -->
        <main class="modal__content">
          <div class="modal__body">

            <!-- Search Type Selection -->
            <fieldset class="form-group" [attr.data-track-region]="dialogHeadline">
              <legend class="form-label mb-3">
                {{ translations.textSearchBy }}
              </legend>

              <div class="control-wrapper my-3" [formGroup]="multiVinForm">
                <!-- VIN Radio Option -->
                <div class="custom-control custom-radio mt-3">
                  <input
                    id="action-vin"
                    type="radio"
                    name="action"
                    class="custom-control-input"
                    formControlName="action"
                    [value]="ActionSelection.Vin"
                    data-track-elem="radio"
                    data-track-name="VIN"
                    [attr.aria-describedby]="'vin-description'"
                    (change)="onRadioSelection(ActionSelection.Vin)" />

                  <label class="custom-control-label" for="action-vin">
                    {{ translations.textVin }}
                  </label>
                </div>

                <!-- Stock Number Radio Option -->
                <div class="custom-control custom-radio mt-3">
                  <input
                    id="action-stock"
                    type="radio"
                    name="action"
                    class="custom-control-input"
                    formControlName="action"
                    [value]="ActionSelection.Stock"
                    data-track-elem="radio"
                    [attr.data-track-name]="getStockMvaReferenceForDataTrack()"
                    [attr.aria-describedby]="'stock-description'"
                    (change)="onRadioSelection(ActionSelection.Stock)" />

                  <label class="custom-control-label" for="action-stock">
                    {{ translations.textStockNumber }}
                  </label>
                </div>
              </div>
            </fieldset>

            <!-- Instructions -->
            <p class="instruction-text mb-3" role="status" aria-live="polite">
              {{ instructionMessage$() }}
            </p>

            <!-- Multi-Entry Form -->
            <form
              name="multiVinForm"
              [formGroup]="multiVinForm"
              novalidate
              allytm-async
              (ngSubmit)="onSubmit()">

              <div class="form-group">
                <div class="d-flex flex-column app-textarea">
                  <textarea
                    id="multi-vin-textarea"
                    formControlName="entries"
                    class="form-control"
                    [class.is-invalid]="hasEntriesError"
                    [attr.aria-invalid]="hasEntriesError"
                    cols="60"
                    rows="8"
                    (input)="onTextAreaInput()">
                  </textarea>

                  <!-- Error Message -->
                  @if (hasEntriesError) {
                    <div
                      id="entries-error"
                      class="alert alert-danger mt-2 fw-bold"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true">
                      <span>
                        {{ translations.textExceeded }}
                        {{ entriesErrorCount }}
                      </span>
                    </div>
                  }
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="modal__actions d-flex gap-2 flex-wrap">
                <button
                  type="submit"
                  class="btn btn-primary me-md-2 mb-3 mb-md-0"
                  [disabled]="multiVinForm.invalid || hasEntriesError"
                  data-track-elem="button"
                  data-track-name="Search"
                  [attr.aria-describedby]="hasEntriesError ? 'entries-error' : null">
                  <span>{{ translations.labelSearch }}</span>
                </button>

                <button
                  type="button"
                  class="btn btn-outline-primary"
                  [attr.aria-label]="translations.btnClear"
                  (click)="clearInput()">
                  <span>{{ translations.btnClear }}</span>
                </button>
              </div>
            </form>
          </div>
        </main>

        <!-- Close Button -->
        <button
          type="button"
          class="modal__close"
          [attr.aria-label]="translations.modalClose"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close"
          (click)="closeMicroModal()">

          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</ng-container>

